module.exports = __webpack_public_path__ + "static/media/dish_card10.6d38c34d.png";